import React from 'react';

const PortfolioPostApproach = () => {
    return (
        <section data-padding="top">
            <div className="stg-row stg-bottom-gap">
                <div className="stg-col-6">
                    <h2 data-appear="fade-up" data-unload="fade-left">Our Approach</h2>
                </div>
            </div>
            <div className="stg-row stg-bottom-gap-l" data-appear="fade-up" data-delay="100" data-unload="fade-right">
                <div className="stg-col-9 stg-offset-3 stg-tp-col-10 stg-tp-offset-2">
                    <p className="infocolors-large-text">We embarked on a collaborative journey with Curology, starting with in-depth research into their target audience and the evolving landscape of digital healthcare. We conducted workshops to uncover the brand's core values and storytelling potential, crafting a narrative that emphasized individuality and a personalized approach.</p>
                </div>
            </div>
            <div className="stg-row" data-appear="fade-left" data-unload="fade-left">
                <div className="stg-col-9">
                    <img className="infocolors-lazy" src="img/null.png" data-src="img/portfolio/portfolio01/slider03.jpg" alt="Curology" width="1200" height="1200" />
                </div>
            </div>
        </section>
    );
};

export default PortfolioPostApproach;
